import { render, staticRenderFns } from "./purchaseinquire.vue?vue&type=template&id=c29559ca&scoped=true&"
import script from "./purchaseinquire.vue?vue&type=script&lang=js&"
export * from "./purchaseinquire.vue?vue&type=script&lang=js&"
import style0 from "./purchaseinquire.vue?vue&type=style&index=0&id=c29559ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29559ca",
  null
  
)

export default component.exports